import { AnyAction, Middleware } from 'redux';
import { PageState } from 'models/PageState';
import { UPDATE_CURRENT_PAGE } from 'components/Pagelayout/actions';
import { loadFromSessionStorage, ARTICLELIST_KEY, removeFromSessionStorage } from 'utils';
import { RESTORE_EDITORIALS } from './actions';
import { isEditorialPage } from 'models/EditorialPageModel';
import { EditorialLink } from 'models/EditorialLink';

interface ArticlePage {
  totalCount?: number;
}

const isArticlePage = (model: unknown): model is ArticlePage =>
  (model as ArticlePage).totalCount === 0;

export const restoreArticleListMiddleware: Middleware<unknown, PageState> =
  store => next => (action: AnyAction) => {
    const result = next(action);
    if (
      action.type === UPDATE_CURRENT_PAGE &&
      !isArticlePage(action.newPage) &&
      isEditorialPage(action.newPage)
    ) {
      const currentPage = action.newPage.nextPage - 1;
      const previousArticleList = restoreArticleList(currentPage);

      if (previousArticleList) {
        store.dispatch({
          type: RESTORE_EDITORIALS,
          editorials: previousArticleList
        });
      }
    }

    return result;
  };

interface SavedProducts {
  pathname: string;
  nextPage: number;
  editorials: EditorialLink[];
}

function restoreArticleList(currentPage: number): EditorialLink[] | undefined {
  const savedProducts = loadFromSessionStorage<SavedProducts>(ARTICLELIST_KEY);
  if (savedProducts) {
    const { pathname, nextPage, editorials } = savedProducts;

    if (pathname === window.location.pathname && nextPage === currentPage) {
      return editorials;
    } else {
      removeFromSessionStorage(ARTICLELIST_KEY);
    }
  }
  return undefined;
}
